import { all } from "redux-saga/effects";

// import all sagas here
import authSaga from './auth/index'
import studentSaga from "./student/index"

export default function* watchAll() {
  yield all([
    ...authSaga,
    ...studentSaga
  ]);
}
